var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.47,
    height: 16.46,
    viewBox: "0 0 16.47 16.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9035173_star_favorite_icon",
    "data-name": "9035173_star_favorite_icon",
    d: "M29.01,48.443a.525.525,0,0,1-.322-.11l-4.413-3.425-4.413,3.425a.52.52,0,0,1-.648,0,.612.612,0,0,1-.194-.662l1.721-5.458L16.28,38.936a.61.61,0,0,1-.214-.658.555.555,0,0,1,.523-.415h5.5l1.661-5.472a.539.539,0,0,1,1.045,0l1.661,5.474h5.5a.555.555,0,0,1,.525.414.61.61,0,0,1-.214.659l-4.463,3.273,1.72,5.456a.622.622,0,0,1-.074.53A.539.539,0,0,1,29.01,48.443Z",
    transform: "translate(-16.041 -31.985)",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue_star.69fa58184eafe42f3485bf309b75e1d8.svg";
export { ForwardRef as ReactComponent };